module.exports = __webpack_public_path__ + "media/images/redesign-images/home/home-5-medium-44ddfa756ac0ea2bea1cf3fd00b49c7f.jpg";